<template>
  <page
    :back-to="getPreviousUrl"
    :title="`Magazine / Issues /` + $route.params.id"
    size="is-desktop"
    :loading="issue.loading"
  >
    <div v-if="issue.data">
      <div class="box">
        <h1 class="title is-5">Pages</h1>
        <b-table class="is-middle" :data="contentConfig.chapters">
          <template slot-scope="props">
            <b-table-column label="Page" width="100">
              <b-dropdown>
                <a slot="trigger">
                  <img
                    style="height: 50px;"
                    :src="contentConfig.thumb_url + props.row.thumb"
                  />
                </a>
                <div class="dropdown-item">
                  <img :src="contentConfig.thumb_url + props.row.screenshot"/>
                </div>
              </b-dropdown>
            </b-table-column>
            <b-table-column label="Number" centered>{{
                props.row.page_number
              }}
            </b-table-column>
            <b-table-column label="Title">
              <div>{{ props.row.title ? props.row.title : "No title" }}</div>
              <div class="has-text-grey is-size-7">
                {{
                  props.row.category ? props.row.category : "Uncategorized"
                }}
                / {{ props.row.keyword ? props.row.keyword : "No keywords" }}
              </div>
            </b-table-column>
            <b-table-column>
              <div class="is-pulled-right">
                <modal-opener-full
                  :component="require('./CreateFeedModal').default"
                  :props="{
                    feed: {
                      title: props.row.title,
                      locale: 'en',
                      issue_id: issue.data.id,
                      page_number: props.row.page_number,
                      cover_url: issue.data.cover_image_url,
                      cover_path: issue.data.cover_image_path,
                      background_url: '',
                      background_path: '',
                      background_ratio : 1,
                      description: '',
                      starts_at: '',
                      ends_at: '',
                      path: contentConfig.thumb_url.split('/contents')[1],
                      image_path: contentConfig.thumb_url.split('/contents')[1]+props.row.screenshot.split('screenshot')[0],
                      html_path: contentConfig.thumb_url+props.row.path,
                    }
                  }"
                >
                  <b-button class="mr-3" slot="trigger">
                    <b-icon icon="plus" style="height: 100%"></b-icon>
                  </b-button>
                </modal-opener-full>
                <links-dropdown
                  :links="[
                    {
                      label: 'Deep Link',
                      url: `${dl}://q?type=read_issue&id=${issue.data.id}&page=${props.row.page_number}`,
                    },
                  ]"
                ></links-dropdown>
              </div>
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
  </page>
</template>
<script>
export default {
  data() {
    return {
      issue: new window.RemoteData(() => {
        return `/admin/api/magazine/issues/${this.$route.params.id}`;
      }),
      dl: this.$store.state.config.app.dl,
      textJson: null,
      modalData: null,
      createModal: false,
      contentConfig: null,
    };
  },
  created() {
    this.issue.load(() => {
      this.contentConfig = this.issue.response.data.content_config;
    });
  },

  computed: {
    getPreviousUrl() {
      return localStorage.getItem('previous');
    },
  }
};
</script>
